import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import "../../assets/css/footer.css";
import NavBarLandingPage from "./NavBarLandingPage";
import TermsConditionVector from "../../assets/images/termsandconditionvector.png";
import FooterLandingpage from "./FooterLandingpage";
function Termscondition() {
  const stylesMain = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "2.5rem",
      fontWeight: 600,
      lineHeight: "25px",
      letterSpacing: "0em",
      textAlign: "left",
      "@media (max-width: 600px)": {
        fontSize: "2.5rem",
      },
    },
  };
  const styles = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "2.5rem",
      fontWeight: 600,
      lineHeight: "25px",
      letterSpacing: "0em",
      textAlign: "left",
      "@media (max-width: 600px)": {
        fontSize: "2rem",
        lineHeight: "48px",
      },
      "@media (max-width: 900px)": {
        fontSize: "2.3rem",
        lineHeight: "45px",
      },
    },
  };
  const description = {
    typography: {
      fontFamily: "Roboto Flex",
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "28px",
      letterSpacing: "0em",
      textAlign: "left",
      "@media (max-width: 600px)": {
        fontSize: "16px", // Adjust the font size for smaller screens
        lineHeight: "24px", // Adjust other styles as needed
      
      },
    },
  };
  return (
    <div>
      <NavBarLandingPage />
      <div className="terms-and-condition-background landing-page">
        <Box
          sx={{
            backgroundColor: "#1E53E8",
            borderRadius: "30px",
            padding: "3rem",
            margin: "40px",
            position: "relative",
            "@media (max-width: 1024px)": {
              margin: "32px",
              padding:"30px"
            },
            "@media (max-width: 600px)": {
              padding: "1.5rem",
              margin: "0px",
              borderRadius: "22px",
            },
            
          }}
        >
          <Typography
            sx={{
              ...stylesMain.typography,
              color: "#fff",
              textTransform: "uppercase",
              marginTop: "50px",
              height: "50px",
              "@media (max-width: 900px)": {
                marginTop: "15px",
            },
            }}
          >
            TERMS & CONDITIONS
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: "#fff",
              marginTop: "30px",
              "@media (max-width: 1024px)": {
                marginTop: "20px",
            },
           
            }}
          >
            The Website Owner, including subsidiaries and affiliates ("Website"
            or "Website Owner" or "we" or "us" or "our") provides the
            information contained on the website or any of the pages comprising
            the website ("website") to visitors ("visitors") (cumulatively
            referred to as "you" or "your" hereinafter) subject to the terms and
            conditions set out in these website terms and conditions, the
            privacy policy and any other relevant terms and conditions,
            policies, and notices which may be applicable to a specific section
            or module of the website.
          </Typography>
          <img
            src={TermsConditionVector}
            alt=""
            style={{ position: "absolute", right: "0", bottom: "0" }}
          />
        </Box>
        <Box
          sx={{
            borderRadius: "30px",
            backgroundColor: " #F1F1F1",
            padding: "3rem",
            marginTop: "2rem",
            marginBlockEnd: "6rem",
            margin: "40px",
            "@media (max-width: 1024px)": {
              margin: "32px",
              padding: "30px",
            },
            "@media (max-width: 600px)": {
              padding: "1.8rem",
              margin: "0px",
              borderRadius: "22px",
              marginTop:"20px"
            },
            
          }}
        >
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "0px",
              "@media (max-width: 900px)": {
                marginTop:"15px"
              },
             }}
          >
            Welcome To Our Website
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              // padding: "10px 5px",
            }}
          >
            If you continue to browse and use this website you are agreeing to
            comply with and be bound by the following terms and conditions of
            use, which together with our privacy policy govern MEGACONNECT
            TECHNOLOGIES PRIVATE LIMITED's relationship with you in relation to
            this website.
          </Typography>
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            The Term
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              // padding: "10px 5px",
            }}
          >
            The term 'MEGACONNECT TECHNOLOGIES PRIVATE LIMITED' or 'us' or 'we'
            refers to the owner of the website whose registered/operational
            office is third floor sy no-30,31,32 singnature mall,lingad road
            Vijayapura KARNATAKA 586103. The term 'you' refers to the user or
            viewer of our website.
          </Typography>
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            The use of this website is subject to the following terms of use:
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
            }}
          >
            <ul>
              <li style={{ marginBottom: "10px" }}>
                The content of the pages of this website is for your general
                information and use only. It is subject to change without
                notice.
              </li>

              <li
                style={{ marginBottom: "10px" }}
                sx={{ marginBottom: "10px" }}
              >
                Neither we nor any third parties provide any warranty or
                guarantee as to the accuracy, timeliness, performance,
                completeness or suitability of information and materials found
                or offered on this website for any particular purpose. You
                acknowledge that such information and materials may contain
                inaccuracies or errors and we expressly exclude liability for
                any such inaccuracies or errors to the fullest extent permitted
                by law.
              </li>

              <li style={{ marginBottom: "10px" }}>
                Your use of any information or materials on this website is
                entirely at your own risk, for which we shall not be liable. It
                Shall be your own responsibility to ensure that any products,
                services or information available through this website meet your
                specific requirements.
              </li>

              <li style={{ marginBottom: "10px" }}>
                This website contains material which is owned by or licensed to
                us. This material includes, but is not limited to, the design,
                layout, look, appearance and graphics. Reproduction is
                prohibited other than in accordance with the copyright notice,
                which forms part of these terms and conditions.
              </li>

              <li style={{ marginBottom: "10px" }}>
                All trademarks reproduced in this website which are not the
                property of, or licensed to, the operator are acknowledged on
                the website.
              </li>

              <li style={{ marginBottom: "10px" }}>
                Unauthorized use of this website may give rise to a claim for
                damages and/or be a criminal offense.
              </li>

              <li style={{ marginBottom: "10px" }}>
                From time to time this website may also include links to other
                websites. These links are provided for your convenience to
                provide further information.
              </li>

              <li style={{ marginBottom: "10px" }}>
                You may not create a link to this website from another website
                or document Without MEGACONNECT TECHNOLOGIES PRIVATE LIMITED's
                prior written consent.
              </li>

              <li style={{ marginBottom: "10px" }}>
                Your use of this website and any dispute arising out of such use
                of the website is subject to the laws of India or other
                regulatory authority.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Authorization Limit Declines
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: "#000000",
              marginTop: "16px",
            }}
          >
            We as a merchant shall be under no liability whatsoever in respect
            of any loss or damage arising directly or indirectly out of the
            decline of authorization for any Transaction, on Account of the
            Cardholder having exceeded the preset limit mutually agreed by us
            with our acquiring bank from time to time.
          </Typography>
        </Box>
      </div>
      <FooterLandingpage />
    </div>
  );
}

export default Termscondition;
